import { Component, inject, OnInit } from '@angular/core';
import { AlertService } from '@app/core/alert/alert.service';

@Component({
    templateUrl: 'about.component.html',
    standalone: true,
    styleUrls: ['about.component.css']
})
export class AboutComponent implements OnInit{
    private alertService = inject(AlertService);

ngOnInit() {  
    this.alertService.success('✅ Have a nice day!', { keepAfterRouteChange: true } );
}
}